import {
  IconMoon,
  IconScubaMask,
  IconShieldCheckFilled,
  IconSun,
} from '@tabler/icons-react';
import { FC } from 'react';

interface Props {
  boatName: string;
  tripDate: string;
  routeName: string;
  numberOfDays: number;
  numberOfNights: number;
  numberOfDives: number;
}

const TripInfoComponent: FC<Props> = ({
  boatName,
  tripDate,
  routeName,
  numberOfDays,
  numberOfNights,
  numberOfDives,
}) => {
  return (
    <div className="mt-6 flex flex-col items-start gap-4 self-stretch">
      <div className="flex flex-col items-start gap-4 self-stretch">
        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold">{boatName}</span>
          <span className="bg-white leading-normal text-status-success">
            <IconShieldCheckFilled size={20} />
          </span>
        </div>
        <div className="flex items-center gap-6 self-stretch">
          <div className="flex flex-col items-start gap-2">
            <span>{tripDate}</span>
            <div className="flex items-center gap-2 text-neutral-500">
              <span>
                <IconSun size={20} />
              </span>
              <span>{numberOfDays}D</span>
              <span className="text-neutral-100">|</span>
              <span>
                <IconMoon size={20} />
              </span>
              <span>{numberOfNights}N</span>
            </div>
          </div>
          <div className="flex flex-col items-start gap-2">
            <span className="font-semibold">{routeName}</span>
            <div className="flex items-center gap-1 text-neutral-500">
              <span>
                <IconScubaMask size={20} />
              </span>
              <span>{numberOfDives} dives</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TripInfoComponent;
